mutation RemoveChannelFromEvent($eventId: ID!, $broadcasterUserId: String!) {
  result: StreamToolsRemoveChannelFromEvent(eventId: $eventId, broadcasterUserId: $broadcasterUserId) {
    id
    deleted
  }
}
